import { concat, get } from 'lodash-es';
import { objectToQueryString } from 'site-modules/shared/utils/string';

/**
 * Gets featureFlag Object to pass through body of lead submission payload...
 * @returns {object}
 */
export const getFeatureFlags = customConfig => {
  const { featureFlags } = customConfig;

  return featureFlags
    ? featureFlags.split(',').reduce((acc, value) => {
        acc[value] = true;
        return acc;
      }, {})
    : {};
};

/**
 * Appends #prepaid_phone tag for prepaid phone to the list of tags coming from custom lead form config.
 * @returns {String[]}
 */
export const getTags = (isPrepaidPhone, tags) => {
  let tagsToReturn = [];

  if (tags) {
    tagsToReturn = concat(tagsToReturn, tags);
  }

  if (isPrepaidPhone) {
    tagsToReturn = concat(tagsToReturn, '#prepaid_phone');
  }

  return tagsToReturn;
};

/**
 * Adjusts submission URL with a `queryParams` from `additionalData`.
 * @param {object} additionalData
 * @param {string} url
 * @returns {string}
 */
export const adjustLeadSubmissionURL = (additionalData, url) => {
  const additionalQueryParams = get(additionalData, 'queryParams');

  if (!additionalQueryParams) return url;

  const queryParams = objectToQueryString(additionalQueryParams);

  return url.includes('?') ? `${url}&${queryParams}` : `${url}?${queryParams}`;
};

/**
 * Returns creative id either from lead form custom config or from default lead form configuration
 * @returns {string}
 */
export const getCurrentCreativeId = (config, customConfig) => {
  const { dataTrackingParent } = config;
  return get(customConfig, 'creativeId', get(dataTrackingParent, 'creativeId'));
};
